const youtubeVideos = document.querySelectorAll('.video-youtube');
const localVideos = document.querySelectorAll('.video-local');
const videoPlayingClass = 'video--playing';
const players = {};

const addScripts = () => {
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

const initYoutube = (placeholderId, videoId) => {
  players[videoId] = new YT.Player(placeholderId, {
    videoId,
    width: 600,
    height: 400,
  });
};

const addClickEvents = (video, id) => {
  video.addEventListener('click', ({ target }) => {
    if (video.contains(target)) {
      video.classList.add(videoPlayingClass);
      players[id].playVideo();
    }
  });
};

window.onYouTubeIframeAPIReady = () => {
  if (youtubeVideos.length > 0) {
    youtubeVideos.forEach((video) => {
      const placeholderId = video.querySelector('.video-iframe-placeholder').id;
      const videoId = placeholderId.replace('video-', '');

      initYoutube(placeholderId, videoId);
      addClickEvents(video, videoId);
    });
  }
};

const playLocalVideo = (video) => {
  video.addEventListener('click', ({ currentTarget }) => {
    currentTarget.classList.add(videoPlayingClass);
    currentTarget.querySelector('video')?.play();
  });
};

(() => {
  if (youtubeVideos.length > 0) {
    addScripts();
  }

  if (localVideos.length > 0) {
    localVideos.forEach((video) => {
      playLocalVideo(video);
    });
  }
})();
